import React, { useEffect, useState } from 'react';
import { Container } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { commonActions } from '../actions/commonActions';
import GlobalModal from '../components/common/GlobalModal';
import Timer from '../components/common/Timer';
import Loader, { ThreeCirclesAnimatedSvg } from '../components/common/loader/Loader';
import { Outlet } from 'react-router-dom';
import NavMenu from '../components/common/navMenu/NavMenu';
import * as commonSelectors from '../components/common/selectors';
import ModalEnum from '../shared/enums/modalEnum';

const Layout = () => {
  const [isRedirect, setRedirect] = useState(false);

  return (
    <div>
      <div className="base-frame">
        <NavMenu
          redirecting={() => setRedirect(true)}
        />
        <Container className="main-frame">
          {
            <Outlet />
          }
        </Container>
        <Timer />
        <Loader />
        <InformationModal />

        {isRedirect &&
          <div
            className="global-loader-frame"
            style={{ visibility: isRedirect ? 'visible' : 'hidden' }}
          >
            <div className="redirect-identity">
              <ThreeCirclesAnimatedSvg />
              <span style={{ color: 'white', fontWeight: 'bold' }}>Redirecting to identity service...</span>
            </div>
          </div>
        }
        <footer
          id="sticky-footer"
          className="text-white-50"
          style={{
            marginTop: '5px',
            display: 'block',
            marginBottom: '5px',
          }}
        >
          <div className="container text-center sticky-footer-div">
            <small>&copy; Oriflame Software s. r. o.</small>
          </div>
        </footer>
      </div>
    </div>
  );
}

const InformationModal = () => {
  const messageObj = useSelector(commonSelectors.message);
  const [isOpen, setOpen] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    setOpen(messageObj.length > 0 || messageObj.text.length > 0);
  }, [messageObj]);

  const closeMessage = () => dispatch(
    commonActions.setMessage({
      text: "",
      html: false
    })
  );

  return (
    <GlobalModal
      isOpen={isOpen}
      close={closeMessage}
      content={{
        text: messageObj?.text ?? messageObj ?? "",
        html: messageObj?.html ?? false,
      }}
      type={ModalEnum.Information}
    />
  );
};

export default Layout;
